import React, {useEffect, useRef, useState} from 'react';

export const StepCarousel = (props) => {
  const {list, onClick, onHover, activeStep} = props;

  const handleClick = (step) => {
    onClick && onClick(step);
  };

  const handleHover = (step) => {
    onHover && onHover(step);
  };

  return (
    <div className='step-carousel row'>
      {list.map((item, index) => (
        <div>
          <img className='step-main-image' key={index} src={item.img} hidden={activeStep !== index + 1} />
        </div>
      ))}
      {list.map((item, index) => (
        <div
          key={index}
          onMouseEnter={() => handleHover(index + 1)}
          onClick={() => handleClick(index + 1)}
          className='col-md-3 select'
          style={{width: item.width}}>
          {item.children}
        </div>
      ))}
    </div>
    
  );
};
